import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the store settings screens a "Settings" crumb. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings')({
  staticData: { crumb: 'common:nav.storeSettings' },
  component: Outlet,
});
